import ActionTypes from './types';

export const UPDATE_EVENT_STATUS = 'event/UPDATE_EVENT_STATUS';
export const UPDATE_CURRENT_EVENT = 'event/UPDATE_CURRENT_EVENT';

export function updateEventStatus(event_status) {
  return {
    type: ActionTypes.UPDATE_EVENT_STATUS,
    payload: event_status,
  };
}

export function updateCurrentEvent(data) {
  return {
    type: ActionTypes.UPDATE_CURRENT_EVENT,
    payload: {
      data,
    },
  };
}
